import type React from "react";
import {useEffect, useRef} from "react";

import {useFrame} from "@react-three/fiber";
import type {Mesh} from "three";

import {useSelection} from "../useSelection";

const BoundingBoxMesh: React.FC = () => {
  const {selectionBoundingBox, recalculateBoundingBox} = useSelection();
  const meshRef = useRef<Mesh>(null);

  useEffect(() => {
    recalculateBoundingBox();
  }, [recalculateBoundingBox]);

  useFrame(() => {
    if (meshRef.current) {
      if (selectionBoundingBox.current === null) {
        // Hide the bounding box when there’s no selection
        meshRef.current.scale.set(0, 0, 0);
      } else {
        // Update the bounding box position and scale when there’s a selection
        meshRef.current.position.set(
          selectionBoundingBox.current.position.x,
          selectionBoundingBox.current.position.y,
          49,
        );
        meshRef.current.scale.set(
          selectionBoundingBox.current.scale.x,
          selectionBoundingBox.current.scale.y,
          1,
        );
        meshRef.current.rotation.copy(selectionBoundingBox.current.rotation);
      }
    }
  });

  return (
    <mesh ref={meshRef}>
      <planeGeometry args={[1, 1]} />
      <meshBasicMaterial color="black" wireframe />

      <mesh>
        <circleGeometry args={[0.01, 32]} />
        <meshBasicMaterial color="orange" />
      </mesh>
    </mesh>
  );
};

export default BoundingBoxMesh;
